var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filebrowser",on:{"ondrop":_vm.setFile}},[_c('UploadIcon',{staticClass:"icon"}),_vm._v(" Загрузить файл "),_c('input',{attrs:{"type":"file","accept":_vm.data.req,"multiple":""},on:{"change":_vm.setFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }